export class EditCollectionPointRemoveDumpstersInput {
  collectionPointId: number;
  dumpsters: number[];

  constructor(collectionPointId: number, dumpsters: number[]) {
    this.collectionPointId = collectionPointId;
    this.dumpsters = dumpsters;
  }
}
